$(document).ready(function () {

  $('.swiper-education-products').each(function (index, elem) {
    const breakpoint = window.matchMedia( '(min-width:750px)' );
    let collectionGridSwiper;

    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
      if ( collectionGridSwiper !== undefined ) collectionGridSwiper.destroy( true, true );
      return;
        } else if ( breakpoint.matches === false ) {
          return enableSwiper();
        }
    };

    const enableSwiper = function () {
     collectionGridSwiper = new Swiper(elem, {
       direction: 'horizontal',
       slidesPerView: 2,
       spaceBetween: 10,
       grabCursor: true,
       freeMode: false,
       loop: false,
       scrollbar: {
         el: '.swiper-scrollbar',
       },
      });
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  });


});
